export default __webpack_public_path__ + "static/AppBeers11-b18b55b65fdd5207cde7dba435f216af.png";